import { render, staticRenderFns } from "./ProductProfilesTable.vue?vue&type=template&id=0336912e&"
import script from "./ProductProfilesTable.vue?vue&type=script&lang=js&"
export * from "./ProductProfilesTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductProfilesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports